import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SubscriptionService } from '../subscription.service';
import { faCircleCheck, faSpinner } from '@fortawesome/free-solid-svg-icons';

@Component({
  standalone: false,
  selector: 'app-sub-checkout-success',
  templateUrl: './sub-checkout-success.component.html',
  styleUrls: ['./sub-checkout-success.component.css']
})
export class SubCheckoutSuccessComponent implements OnInit {

  faCircleCheck = faCircleCheck;
  faSpinner = faSpinner;

  isLoading = true;
  isError = false;
  errorMessage = '';

  constructor(
    private activatedRoute: ActivatedRoute,
    private subscriptionService: SubscriptionService
  ) { }

  ngOnInit() {
    const sessionId = this.activatedRoute.snapshot.queryParamMap.get('session_id');
    if (sessionId) {
      this.subscriptionService.upsertUserSubscriptions().subscribe({
        next: () => {
          this.isLoading = false;
        },
        error: (err) => {
          console.error('Failed to sync subscriptions', err);
          this.isLoading = false;
          this.isError = true;
          this.errorMessage = 'We could not sync your subscription. Please contact support if the issue persists.';
        }
      });
    } else {
      this.isLoading = false;
      this.isError = true;
      this.errorMessage = 'Buying the subscription failed. Please try again or contact support.';
    }
  }
}
